// extracted by mini-css-extract-plugin
export var root = "title-module--root--2e659";